import PropTypes from 'prop-types'
import React from 'react'
import classNames from 'classnames'
import logo from 'assets/images/logo.svg'
import { withStyles } from '@material-ui/core/styles'

export const styles = theme => ({
  root: {
    padding: `${theme.spacing(2)}px 0`,
    marginBottom: theme.spacing(2),
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
  },
  logo: {
    width: 100,
    height: 100,
    [theme.breakpoints.up('sm')]: {
      width: 150,
      height: 150,
    },
  },
  centered: {
    margin: 0,
  },
  title: {
    width: 160,
  },
})

const Logo = ({
  classes, className: classNameProp, hideText, ...imgProps
}) => (
  <div className={classNames(classes.root, classNameProp)}>
    <img
      src={logo}
      {...imgProps}
      alt="Chirp Logo"
      className={classNames(classes.logo, hideText && classes.centered)}
    />
  </div>
)

Logo.propTypes = {
  classes: PropTypes.object.isRequired,
  className: PropTypes.string,
  hideText: PropTypes.bool,
}

Logo.defaultProps = {}

export default withStyles(styles)(Logo)



// WEBPACK FOOTER //
// ./src/components/atoms/Logo.js